var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 5.33333C4.66699 3.49238 6.15938 2 8.00033 2C9.84127 2 11.3337 3.49238 11.3337 5.33333C11.3337 7.17428 9.84127 8.66667 8.00033 8.66667C6.15938 8.66667 4.66699 7.17428 4.66699 5.33333ZM8.00033 7.33333C9.1049 7.33333 10.0003 6.4379 10.0003 5.33333C10.0003 4.22876 9.1049 3.33333 8.00033 3.33333C6.89576 3.33333 6.00033 4.22876 6.00033 5.33333C6.00033 6.4379 6.89576 7.33333 8.00033 7.33333Z",
    fill: "#42455F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22909 10.8954C3.2289 11.8956 2.66699 13.2522 2.66699 14.6667H4.00033C4.00033 13.6058 4.42175 12.5884 5.1719 11.8382C5.92204 11.0881 6.93946 10.6667 8.00033 10.6667C9.06119 10.6667 10.0786 11.0881 10.8288 11.8382C11.5789 12.5884 12.0003 13.6058 12.0003 14.6667H13.3337C13.3337 13.2522 12.7718 11.8956 11.7716 10.8954C10.7714 9.89524 9.41481 9.33333 8.00033 9.33333C6.58584 9.33333 5.22928 9.89524 4.22909 10.8954Z",
    fill: "#42455F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUser);
export default __webpack_public_path__ + "static/media/notification-user.2228999c.svg";
export { ForwardRef as ReactComponent };